module.exports = __webpack_public_path__ + "img/131.bab91d2d.jpg";